// extracted by mini-css-extract-plugin
module.exports = {"isContentsAreaStyle":"ShareIcons_isContentsAreaStyle_p-WWz","shareIcon":"ShareIcons_shareIcon_hfKEu"};